module.exports = __webpack_public_path__ + "img/map1.08340c5f.jpg";